export { app } from './app.lang';
export { bma } from './bma.lang';
